export function isOutside(element, clicked) {

    if (element && clicked) {
        return !element.contains(clicked)
    }
}
